import { ENDPOINTS } from 'utils/api/callApi'
import { ITransfixLanesParams } from './types'

export enum TRANSFIX_LANES_ACTION_TYPES {
  FETCH_TRANSFIX_LANES_REQUEST = 'FETCH_TRANSFIX_LANES_REQUEST',
  FETCH_TRANSFIX_LANES_SUCCESS = 'FETCH_TRANSFIX_LANES_SUCCESS',
  FETCH_TRANSFIX_LANES_FAILURE = 'FETCH_TRANSFIX_LANES_FAILURE',
}

export const getTransfixLanes = (params: ITransfixLanesParams) => {
  const requestData = {
    endpoint: ENDPOINTS.transfixLanes,
    params,
  }

  return {
    type: '',
    payload: {
      callApi: true,
      requestData,
      actionTypes: Object.keys(TRANSFIX_LANES_ACTION_TYPES),
    },
  }
}
